/**
 * Author: Qian.qianchen 2018-11-13
 * discription: 产品管理 微博 微博账号编辑
 */
"use strict";
angular.module("productManageMentEditToutiaohaoModule", [])
    .controller('productManageMentEditToutiaohaoCtrl', ['$scope', '$modalInstance', 'modalDialog', 'item', 'trsHttpService', '$validation', function($scope, $modalInstance, modalDialog, item, trsHttpService, $validation) {
        initStatus();

        function initStatus() {

            $scope.data = {
                currUser: {
                    CHNLNAME: item.CHNLNAME,
                    CHANNELID: item.CHANNELID,
                    LINKURL: item.LINKURL,
                    CHNLDESC: item.CHNLDESC,
                    // language: item.LANGUAGE,
                    serviceId: 'mlf_toutiaoconfig',
                    methodName: "saveChannel",
                }
            }
        }
        /**
         * [cancel description] 取消
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
        /**
         * [confirm description] 表单信息提交-确认
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.data.currUser, 'post', true).then(function(data) {
                console.log("修改成功");
                $modalInstance.close({result: true,data:data});
            }, function(data) {
                console.log("修改失败");
                $modalInstance.close({result: false, data:data});
            });
        };
    }]);